 <template>
  <div>
    <v-card class="elevation-0 mt-2 transparent">
      <v-layout justify-left>
        <img class="lindaLogo" :src="getLindaImage(steps[_webStep].image)">
        <v-card round color="#f2f2f2" :class="['lindaText tri-right left-in elevation-1', steps[_webStep].lindaBubbleSize]">
          <v-card-text>
            <p class="fontSize" :style="getFontProperty()">{{$translate(steps[_webStep].text1)}}</p>

            <p
              v-if="steps[_webStep].text2 != null"
              class="fontSize"
              :style="getFontProperty()"
            >{{$translate(steps[_webStep].text2)}}</p>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-card>
  </div>
</template>


<script>
import appConfig from "../../config/app_config.js";
import * as dssRequest from "../api/dssRequest";
import { mapGetters } from "vuex";
import { ui_helpers } from "../shared/ui_helpers.js";
import BaseComponent from "./base/BaseComponent.vue";

export default {
  extends: BaseComponent,
  mixins: [ui_helpers],
  name: "LindaOutput",

  computed: {
    ...mapGetters({
      _webStep: "getWebStepId"
    })
  },
  data() {
    return {
      baseStep: {
        image: null,
        text1: null,
        text2: null,
        lindaBubbleSize: "",
      },
      steps: {}
    };
  },

  created() {
    let copy = JSON.parse(JSON.stringify(this.baseStep));
    copy.image = "Linda_motivated";
    copy.text1 = "LINDA_ACCOUNT_CREATION";
    copy.text2 = "LINDA_ACCOUNT_READY_TO_CREATE";
    this.steps[-1] = copy; //user group base setting

    copy = JSON.parse(JSON.stringify(this.baseStep));
    copy.image = "Linda_jumping";
    copy.text1 = "LINDA_ACCOUNT_CREATION_FIRST_STEP";
    copy.text2 = "LINDA_ACCOUNT_CREATION_FIRST_STEP_DESC";
    this.steps[-2] = copy; //user register correctly

    copy = JSON.parse(JSON.stringify(this.baseStep));
    copy.image = "Linda_motivated";
    copy.text1 = "LINDA_ACCOUNT_MADE_TITLE";
    copy.text2 = "LINDA_ACCOUNT_MADE_BODY";
    this.steps[-3] = copy; //user register correctly

    copy = JSON.parse(JSON.stringify(this.baseStep));
    copy.image = "Linda_motivated";
    copy.text1 = "LINDA_WELCOME_BACK";
    copy.text2 = "LINDA_USER_TRIPLIST";
    this.steps[0] = copy; //user trip list

    copy = JSON.parse(JSON.stringify(this.baseStep));
    copy.image = "Linda_planning";
    copy.text1 = "LINDA_WHERE_TO";
    copy.text2 = "LINDA_SEARCH_EVENT";
    this.steps[1] = copy; //user search event

    copy = JSON.parse(JSON.stringify(this.baseStep));
    copy.image = "Linda_planning";
    copy.text1 = "LINDA_DATE_PICKER_WELCOME";
    copy.text2 = "LINDA_DATE_PICKER";
    this.steps[2] = copy; //user date picker

    copy = JSON.parse(JSON.stringify(this.baseStep));
    copy.image = "Linda_planning";
    copy.text1 = "LINDA_TRIP_DETAIL";
    copy.text2 = "LINDA_ACTIVITY_LIST";
    copy.lindaBubbleSize = "lindaTextMediumSize"
    this.steps[3] = copy; //user trip detail
    

    copy = JSON.parse(JSON.stringify(this.baseStep));
    copy.image = "Linda_planning";
    copy.text1 = "LINDA_MODE_OF_TRANSPORT";
    copy.text2 = "LINDA_SAVING_A_SPOT";
    this.steps[3] = copy; //user choose mode of transport

    copy = JSON.parse(JSON.stringify(this.baseStep));
    copy.image = "Linda_hands";
    copy.text1 = "LINDA_CHECK_INPUT";
    this.steps[5] = copy; //user confirms order

  },

  methods: {
    getLindaImage(name) {
      return this.customerPreferences[name];
    }
  }
};
</script>
<style>
.lindaLogo {
  height: 25em;
  margin-left: -5em;
}

.lindaText {
  max-height: 15em;
  margin-left: -2.5em !important;
  margin: 15px;
  border-radius: 30px !important;
  max-width: 21em !important;
}

.lindaTextSmallSize {
  max-height: 8em;
  margin-left: -2.5em !important;
  margin: 15px;
  border-radius: 30px !important;
  max-width: 21em !important;
}

.lindaTextMediumSize {
  max-height: 21em !important;
  margin-left: -2.5em !important;
  margin: 15px;
  border-radius: 30px !important;
  max-width: 21em !important;
}
.fontSize {
  font-size: 18px;
}

.fontSize2 {
  font-size: 16px;
}

.tri-right.left-in:after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: -25px;
  right: auto;
  top: 30px;
  bottom: auto;
  border: 13px solid;
  border-color: #f2f2f2 #f2f2f2 transparent transparent;
}

@media screen and (max-width: 960px) {
}
</style>
